import React from "react";
import { Link } from "react-router-dom";
import styles from "./MarketSketch.module.css";
import { BiNews } from "react-icons/bi";
import marketNewsList from "../../data/marketSketchData"; // 뉴스 데이터 불러오기

const MarketSketch = () => {
  return (
    <section className={styles.marketSketch}>
      <h2 className={styles.title}>Market Sketch</h2>
      <div className={styles.newsContainer}>
        {marketNewsList.map((item) => (
          <Link
            key={item.id}
            to={`/marketSketch/${item.id}`}
            className={styles.newsItem}
          >
            <BiNews className={styles.newsIcon} />
            <div className={styles.newsInfo}>
              <strong>{item.title}</strong>
              <p className={styles.newsMeta}>
                {item.author} | {item.date}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default MarketSketch;
